import { Navigate, useLocation } from "react-router-dom";
import { useAgents } from "@/components/Agents/AgentsContext";
import { useSession } from "@/auth/SessionProvider";
import { getActiveKnowledgeBaseId } from "@/lib/knowledgeBaseRegistry";
import {
  knowledgeArticleEditPath,
  knowledgeArticleNewPath,
  knowledgeArticlePath,
  knowledgeArticlesPath,
  knowledgeBasePath,
  knowledgeBookPath,
  knowledgeBooksPath,
  knowledgeLibrariesPath,
  knowledgeLibraryPath,
  knowledgeOverviewPath,
  legacyKnowledgeIsArticleEdit,
  legacyKnowledgeIsArticleNew,
  legacyKnowledgeSection,
  legacyKnowledgeTail,
} from "@/lib/knowledgePaths";
import { refreshKnowledgeRegistryFromApi } from "@/lib/knowledgeRegistryCrossSync";
import { resolveKnowledgeOrgId } from "@/lib/knowledgeOrgId";

/** Redirect flat `/knowledge/...` URLs to `/knowledge/bases/:baseId/...`. */
export function KnowledgeLegacyRedirect() {
  const location = useLocation();
  const { org } = useAgents();
  const session = useSession();
  const orgId = resolveKnowledgeOrgId(session.data?.user?.orgId, org.orgId);
  if (orgId) void refreshKnowledgeRegistryFromApi(orgId);
  const activeId = orgId ? getActiveKnowledgeBaseId(orgId) : "";
  const section = legacyKnowledgeSection(location.pathname);

  if (!activeId) {
    return <Navigate to={knowledgeOverviewPath()} replace state={{ from: location.pathname }} />;
  }

  const tail = legacyKnowledgeTail(location.pathname);
  if (legacyKnowledgeIsArticleNew(location.pathname)) {
    return <Navigate to={knowledgeArticleNewPath(activeId)} replace />;
  }
  if (legacyKnowledgeIsArticleEdit(location.pathname) && tail) {
    return <Navigate to={knowledgeArticleEditPath(activeId, tail)} replace />;
  }

  if (section === "libraries") {
    return (
      <Navigate
        to={tail ? knowledgeLibraryPath(activeId, tail) : knowledgeLibrariesPath(activeId)}
        replace
      />
    );
  }
  if (section === "books") {
    return <Navigate to={tail ? knowledgeBookPath(activeId, tail) : knowledgeBooksPath(activeId)} replace />;
  }
  if (section === "articles") {
    return (
      <Navigate
        to={tail ? knowledgeArticlePath(activeId, tail) : knowledgeArticlesPath(activeId)}
        replace
      />
    );
  }

  return <Navigate to={knowledgeBasePath(activeId)} replace />;
}
